import type { SearchResult } from "$lib/types";
import { simpleHash } from "$lib/utility";

export function getImageUrl(result: SearchResult): string {
  if (result.profilePic && result.profilePic !== "") {
    return result.profilePic;
  } else {
    const fallbackName = (result.firstName || "") + (result.lastName || "") + (result.companyName || "");
    const hashed = simpleHash(fallbackName);
    return `https://www.gravatar.com/avatar/${hashed}?d=identicon&s=256`;
  }
}
